module.exports = __webpack_public_path__ + "img/unitPriceEvaluation_04.f9b05da3.png";